// src/firebaseConfig.js

import {
  getApp,
  getApps,
  initializeApp,
} from "firebase/app";

import {
  getDatabase,
} from "firebase/database";

import {
  getAuth,
} from "firebase/auth";

// =====================================================
// FIREBASE CONFIGURATION
// =====================================================
//
// DfluxSpace Firebase Web SDK configuration.
//
// IMPORTANT:
// Firebase Web configuration values are public client-side
// configuration. They do NOT protect your database.
//
// Actual protection must be handled through:
// - Firebase Authentication
// - Realtime Database Security Rules
//
// =====================================================

const firebaseConfig = {
  apiKey: "AIzaSyBcZalKiXgoh32Pi18VPLY2kOsY6WG_oBE",

  authDomain:
    "dfluxspace.firebaseapp.com",

  projectId:
    "dfluxspace",

  databaseURL:
    "https://dfluxspace-default-rtdb.firebaseio.com",

  storageBucket:
    "dfluxspace.firebasestorage.app",

  messagingSenderId:
    "868788452742",

  appId:
    "1:868788452742:web:119d3e822b4f2b9f42c007",
    
  measurementId:
    "G-KMT6NKJ1EB",
};

// =====================================================
// FIREBASE APP INITIALIZATION
// =====================================================
//
// Reuse an existing Firebase app when available.
//
// This prevents duplicate Firebase initialization during:
// - development
// - hot module reload
// - testing
// - repeated module evaluation
//
// =====================================================

const app =
  getApps().length > 0
    ? getApp()
    : initializeApp(firebaseConfig);

// =====================================================
// FIREBASE REALTIME DATABASE
// =====================================================

const db = getDatabase(app);

// =====================================================
// FIREBASE AUTHENTICATION
// =====================================================

const auth = getAuth(app);

// =====================================================
// EXPORTS
// =====================================================

export {
  app,
  db,
  auth,
  firebaseConfig,
};